import { Button, ButtonColor } from "@/components/catalyst/button";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { useFormState } from "@/lib/Components/Form/Hooks/useFormState";
import { ExclamationTriangleIcon, PlusIcon } from "@heroicons/react/20/solid";
import { FC, ReactNode } from "react";
import { useFormikContext } from "formik";
import { useTranslations } from "use-intl";

export function DialogSubmitButton({
  text,
  color,
  Icon = PlusIcon,
}: {
  text: ReactNode;
  color?: ButtonColor;
  Icon?: FC<any>;
}) {
  const t = useTranslations("common.dialog");
  const { close, reject } = useDialogState();
  const { isSubmitting, submitCount, isValid, submitForm } = useFormikContext();
  const { errorCount } = useFormState();

  const showWarning = submitCount > 1 && !isValid;

  return (
    <div className="col-span-full mt-9 flex justify-end space-x-3">
      <Button
        plain
        onClick={() => {
          reject?.(false);
          close();
        }}
      >
        {t("cancel")}
      </Button>
      <Button
        type="submit"
        isLoading={isSubmitting}
        disabled={isSubmitting}
        color={showWarning ? "red" : color}
        LeadingIcon={showWarning ? ExclamationTriangleIcon : Icon}
        onClick={async (e) => {
          e.preventDefault();
          if (isSubmitting) {
            return;
          }

          await submitForm();
        }}
      >
        {showWarning ? t("errors", { count: errorCount }) : text}
      </Button>
    </div>
  );
}
